export default __webpack_public_path__ + "static/instinct-01b10d0562d3d60a07a8bfb46976334d.png";